import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async create_delivery(data) {
    let response = await apiCall("deliveries/create", data);
    return response;
  },
  async listDeliveries(data) {
    let response = await apiCall("deliveries/list_deliveries", data);
    return response;
  },
  async update_fuel_Delivery(data) {
    let response = await apiCall("deliveries/update_deliveries_details", data);
    return response;
  },
  async station_total_delivered_per_fuel(data) {
    let response = await apiCall(
      "deliveries/station_total_delivered_per_fuel",
      data
    );
    return response;
  },
  async comapny_total_delivered_per_fuel_per_station(data) {
    let response = await apiCall(
      "deliveries/comapny_total_delivered_per_fuel_per_station",
      data
    );
    return response;
  },
};
